import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../custom/BackButton';
import ActionIcon from '../../../custom/ActionIcon';
import { createdUpdatedInfo, getDayName } from '../../../../utils';
import { FormEvent, ICorpStation } from '../../../../globals/interfaces';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    station: ICorpStation;
    workDay: number;
    existingHours: string | undefined;
    updateWorkHours: (stationId: number, day: number, openHours: string) => Promise<void>;
}

export default function ModalTimeSelection({
    modal,
    setModal,
    station,
    workDay,
    existingHours,
    updateWorkHours
}: Props) {

    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    useEffect(() => {
        if (existingHours) {
            const [start, end] = existingHours.split(' - ');
            setStartTime(start);
            setEndTime(end);
        }
    }, [existingHours]);

    const handleSubmit = () => {
        updateWorkHours(station.id, workDay, `${startTime} - ${endTime}`);
        // onSave({ startTime, endTime });
    };

    const toggle = () => setModal(!modal);

    if (!station) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>{station.s_unit}: {getDayName(workDay)}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <label className='pr-4'>
                    Start Time:
                    <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
                </label>
                <label>
                    End Time:
                    <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
                </label>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo({})}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => handleSubmit()} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;